/** Rule-set codes shown in words; a code missing here is shown as it is. */
const RULE_SET_LABELS: Record<string, { label: string; description: string }> = {
  TEN_BO1_TB: { label: 'BO1 · TB', description: 'Best of 1 set, tiebreak at 6-6' },
  TEN_BO3_TB: { label: 'BO3 · TB', description: 'Best of 3 sets, tiebreak at 6-6' },
};

export function ruleSetLabel(code?: string): string {
  return code ? RULE_SET_LABELS[code]?.label ?? code : '';
}

/** The rule in words with its code, for a tooltip; undefined for a code shown as it is. */
export function ruleSetDescription(code?: string): string | undefined {
  const known = code ? RULE_SET_LABELS[code] : undefined;
  return known && code ? `${known.description} (${code})` : undefined;
}
